import script from "./login-setpwd.vue?vue&type=script&lang=ts&setup=true"
export * from "./login-setpwd.vue?vue&type=script&lang=ts&setup=true"

import "./login-setpwd.vue?vue&type=style&index=0&id=7b50fcaf&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b50fcaf"]])

export default __exports__